/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {refreshInstrumentLinkingOptions} from '../api'

export const useMutationRefreshInstrumentLinkingOptions = createReactQueryMutationHook('refreshInstrumentLinkingOptions', refreshInstrumentLinkingOptions)
